"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DetailStatementTable_1 = require("./DetailStatementTable");
var react_1 = require("react");
require("../../styles/CustomerListPage.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var DetailStatementPage = function (props) {
    var statementId = parseInt(props.match.params.id, 10) || 0;
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var onLoad = function () {
    };
    react_1.useEffect(function () {
        if (inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [inProgress]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "Monthly Statement "))),
            React.createElement(DetailStatementTable_1.DetailStatementTable, { statementId: statementId }))));
};
exports.default = DetailStatementPage;
//# sourceMappingURL=DetailStatementPage.js.map